import { bool, func, object } from 'prop-types';
import { Fragment, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

import { Loader, Modal, StrapiImg } from 'components';
import { useSafeState } from 'hooks';
import { appService } from 'services';

import 'assets/styles/components/base/dialog/_modal.scss';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const FileModal = ({ showPDF, onClose, modal }) => {
  const isPdf = modal?.file?.ext?.includes('.pdf');
  const isImage = ['.jpg', '.jpeg', '.png'].includes(modal?.file?.ext);

  const { t } = useTranslation();

  const scale = useRef(1);
  const [numPages, setNumPages] = useSafeState(null);

  useEffect(() => {
    if (!showPDF) return;
    // Adapt PDF Page scale to screen size to avoid blurry effect
    window.innerWidth <= 768 ? (scale.current = 1.2) : (scale.current = 1.5);
  }, [showPDF, window.innerWidth]);

  return (
    <Modal
      isOpen={showPDF}
      size="medium"
      header={
        <a href={`${appService.getStrapiBaseUrl()}${modal?.file?.url}`} download className="btn small outlined">
          {t('buttons.download')}
        </a>
      }
      body={
        <>
          {isImage && <StrapiImg image={modal?.file} className="w-full overflow-hidden rounded-xl" />}

          {isPdf && (
            <Document
              file={`${appService.getStrapiBaseUrl()}${modal?.file?.url}`}
              onLoadSuccess={({ numPages }) => setNumPages(numPages)}
              loading={
                <div className="flex-center-center">
                  <Loader loaderClass="w-6 h-6" />
                </div>
              }
            >
              {Array.from(new Array(numPages), (_, index) => (
                <Fragment key={`document-page-${index}`}>
                  <Page key={`page_${index + 1}`} pageNumber={index + 1} scale={scale.current} />
                  {!(index + 1 === numPages) && <div className="w-full h-[0.13rem] bg-gray-200" />}
                </Fragment>
              ))}
            </Document>
          )}
        </>
      }
      onClose={onClose}
    />
  );
};

FileModal.propTypes = {
  modal: object.isRequired,
  showPDF: bool.isRequired,
  onClose: func.isRequired
};

export default FileModal;
